
















import VueOptions from '@utils/VueOptions'
import RadioGroup from '@ui/AudienceSetWizard/components/RadioGroup'

settings =
  name: 'AudienceAvailabilitySelector'

  vue:
    props: ['value', 'audienceAvailabilities']

    components: {
      RadioGroup,
    }

    data: ->
      type: @initialType()

    computed:
      selectedKeys:
        get: -> @value
        set: (newValue) -> @$emit 'update:value', newValue

      optionsForTypes: ->
        [
          { value: 'all', label: 'All in-Person Venues', iconClass: 'fas fa-user' },
          { value: 'specific', label: 'Specific Venues', iconClass: 'fas fa-crosshairs' },
        ]

      actionsForTypes: ->
        select: @selectType

    methods:
      initialType: ->
        if @audienceAvailabilities.length is @value.length
          return 'all'
        else if @value.length
          return 'specific'
        null

      selectType: (option) ->
        switch option.value
          when 'all'
            @$emit 'update:value', @audienceAvailabilities.map((item) -> item.key)
          when 'specific'
            @$emit 'update:value', []

export default VueOptions.vue settings
